import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Icon from '../../../../../Icon';
import PrivacyIcon from '../../../../../PrivacyIcon';
import { ALLERGIE_TYPE } from '../../../../constants';
import { formatDate } from '../../../../utils';
import styles from '../index.styl';

const AllergiesCard = ({ entity, formatMessage }) => {
  const [activeCard, setActiveCard] = useState(false);
  const {
    name,
    startDate,
    severity,
    allergyType,
    reaction,
    isPrivate,
  } = entity;
  const applyStyleForSeverity = useCallback(
    type => {
      switch (type) {
        case ALLERGIE_TYPE.SEVERE:
          return cn(styles.context, styles.severityPink);
        case ALLERGIE_TYPE.MODERATE:
          return cn(styles.context, styles.severityModerate);
        case ALLERGIE_TYPE.MILD:
          return cn(styles.context, styles.severityGreen);
        default:
          return styles.context;
      }
    },
    [severity],
  );
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.leftSideWrapper}>
          <Icon
            size={28}
            name="icon-allergies-black"
            className={styles.iconType}
          />
          <div className={styles.contentWrapper}>
            <div className={styles.title}>
              <div
                className={cn(styles.titleWrapper, { [styles.noTitle]: !name })}
              >
                {name}
              </div>
              <PrivacyIcon show={isPrivate} className={styles.privacyIcon} />
            </div>
            <div className={styles.description}>{reaction || ''}</div>
          </div>
        </div>
        <Icon
          size={16}
          name={activeCard ? 'icon-arrow-up' : 'icon-arrow-down'}
          className={styles.icon}
          onClick={() => setActiveCard(!activeCard)}
        />
      </div>
      {activeCard && (
        <div className={styles.activeCardRoot}>
          <div className={styles.columnWrapper}>
            <div className={styles.column}>
              <div className={styles.meta}>
                {formatMessage({
                  id: 'patient.portal.allergies.severity',
                })}
              </div>
              <div className={styles.meta}>
                {formatMessage({ id: 'patient.portal.allergies.type' })}
              </div>
            </div>
            <div className={styles.column}>
              <div className={applyStyleForSeverity(severity)}>
                {severity || ''}
              </div>
              <div className={styles.context}>{allergyType || ''}</div>
            </div>
          </div>
          <div className={styles.columnWrapper}>
            <div className={styles.column}>
              <div className={styles.meta}>
                {formatMessage({
                  id: 'patient.portal.allergies.effectiveDate',
                })}
              </div>
            </div>
            <div className={styles.column}>
              <div className={styles.context}>
                {startDate ? formatDate(startDate, 'MMM D, Y') : ''}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

AllergiesCard.propTypes = {
  entity: PropTypes.object,
  formatMessage: PropTypes.func,
};

export default AllergiesCard;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/AllergieCard/index.jsx